/*
 * The date inputs give a bare day ("2026-09-19"). The page shows each
 * session's time in the viewer's time zone, so the filter must mean the
 * viewer's day too. These turn a day into its first and last millisecond in
 * that zone, as ISO 8601 in UTC, which the studio reads as an exact instant.
 */

const DAY = /^\d{4}-\d{2}-\d{2}$/;

const localInstant = (day: string, time: string): string | undefined => {
  if (!DAY.test(day)) return undefined;
  // A date-time without an offset is read in the local time zone.
  const moment = new Date(`${day}T${time}`);
  return Number.isNaN(moment.getTime()) ? undefined : moment.toISOString();
};

/** The viewer's calendar day of a moment, as "YYYY-MM-DD". */
export const localDayString = (moment: Date): string =>
  [
    moment.getFullYear(),
    String(moment.getMonth() + 1).padStart(2, "0"),
    String(moment.getDate()).padStart(2, "0"),
  ].join("-");

/** The first millisecond of the day in the viewer's time zone; undefined for no or a malformed day. */
export const localDayStart = (day: string | null | undefined): string | undefined =>
  day ? localInstant(day, "00:00:00.000") : undefined;

/** The last millisecond of the day in the viewer's time zone; undefined for no or a malformed day. */
export const localDayEnd = (day: string | null | undefined): string | undefined =>
  day ? localInstant(day, "23:59:59.999") : undefined;
